import { cx } from '@linaria/core';
import { useQuery } from '@tanstack/react-query';
import { useRef, useState } from 'react';
import { Link } from '@provider/navigation';
import { useTrackingManager } from '@provider/tracking';
import { PublisherLogo } from '@ui/kit/icons';
import { triggerEventOnContainerClick } from '@utils/common';
import { useActivityIndicator, PostloadedImage, Chevron } from '@utils/react';
import { getLocationDataQuery } from '../api/get-data.query.js';
import { getLastLocationDescriptorQuery } from '../api/get-last-location.query.js';
import { card, graphic, publisher, textContainer, heading, subheading, link, chevron, linkIcon, throbber } from './_location-card.style.js';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';

function LocationCard() {
  const tracker = useTrackingManager();
  const ref = useRef(null);
  const lastLocationDescriptor = useQuery(getLastLocationDescriptorQuery.useQueryConfig());
  const lastLocationData = useQuery(getLocationDataQuery.useQueryConfig({
    descriptor: lastLocationDescriptor.data?.descriptor
  }));
  const [isNavigating, setNavigating] = useState(false);
  const navigationActivity = useActivityIndicator(isNavigating || lastLocationData.isPending || lastLocationDescriptor.isPending, {
    delayMs: 250,
    durationMs: 500
  });
  if (!lastLocationData.data && lastLocationData.isSuccess) {
    return null;
  }
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    jsxs("div", {
      ref: ref,
      className: card,
      onClick: evt => {
        setNavigating(true);
        triggerEventOnContainerClick({
          ref,
          ignores: ["a", "button"],
          triggerSelector: "[data-link-trigger='true']"
        }, evt);
        tracker.trackEvent("userarea.location", {
          targetId: lastLocationData.data?.type === "course" ? lastLocationData.data.chapterId ?? lastLocationData.data.courseId ?? "" : lastLocationData.data?.pageId ?? "",
          targetPath: lastLocationData.data?.path ?? "",
          targetTitle: lastLocationData.data?.title ?? "",
          targetType: lastLocationData.data?.type === "course" ? "Course" : "Page"
        });
      },
      children: [/*#__PURE__*/jsxs("div", {
        className: graphic,
        children: [!!lastLocationData.data?.vignette && /*#__PURE__*/jsx(PostloadedImage, {
          src: lastLocationData.data.vignette.url,
          width: lastLocationData.data.vignette.width,
          height: lastLocationData.data.vignette.height,
          sizes: "100px",
          alt: lastLocationData.data.vignette.alt ?? ""
        }), /*#__PURE__*/jsx(PublisherLogo, {
          small: true,
          className: publisher
        })]
      }), /*#__PURE__*/jsxs("div", {
        className: textContainer,
        children: [lastLocationData.error && /*#__PURE__*/jsx("span", {
          children: "Noget gik galt, pr\xF8v igen senere."
        }), lastLocationData.isPending && /*#__PURE__*/jsx("span", {
          children: "Indl\xE6ser..."
        }), lastLocationData.data && /*#__PURE__*/jsxs(Fragment, {
          children: [/*#__PURE__*/jsxs("b", {
            className: heading,
            children: [lastLocationData.data?.type === "course" ? "Forløb: " : "", lastLocationData.data?.title]
          }), lastLocationData.data?.type === "course" && lastLocationData.data.chapterTitle && /*#__PURE__*/jsxs("div", {
            className: subheading,
            children: [">", " ", lastLocationData.data.chapterTitle]
          })]
        })]
      }), /*#__PURE__*/jsxs(Link, {
        className: link,
        "aria-label": `Gå til ${lastLocationData.data?.title}`,
        href: lastLocationData.data?.path,
        "data-link-trigger": true,
        children: [/*#__PURE__*/jsx("span", {
          className: cx(linkIcon, !navigationActivity.isActive() && "visible"),
          children: /*#__PURE__*/jsx(Chevron, {
            className: chevron,
            size: 15
          })
        }), /*#__PURE__*/jsx("span", {
          className: cx(linkIcon, navigationActivity.isActive() && "visible"),
          children: /*#__PURE__*/jsx("div", {
            className: throbber
          })
        })]
      })]
    })
  );
}

export { LocationCard };
//# sourceMappingURL=_location-card.js.map
